export const apiBaseUrl = (import.meta.env.VITE_API_BASE_URL || '/api').replace(/\/$/, '');

export async function apiRequest<T>(path: string, options: RequestInit = {}): Promise<T> {
    const response = await fetch(`${apiBaseUrl}${path}`, {
        ...options,
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', ...options.headers },
    });
    if (!response.ok) {
        const body = await response.json().catch(() => null);
        throw new Error(body?.error || body?.detail || `Request failed (${response.status})`);
    }
    return response.json() as Promise<T>;
}
